import { Button } from "@/components/ui/button";
import { useAuth } from "@/_core/hooks/useAuth";
import {
  Brain, Clock, Rocket, CheckCircle2, Zap, BarChart3, Bot, Shield,
} from "lucide-react";

const FEATURES = [
  { icon: BarChart3, label: "Dashboard em tempo real", desc: "Métricas ao vivo das suas campanhas" },
  { icon: Bot, label: "Cérebro Central com IA", desc: "Análise inteligente e recomendações" },
  { icon: Zap, label: "Piloto Automático", desc: "Otimização automática de campanhas" },
  { icon: Shield, label: "Central de Comando", desc: "Execute ações com um clique" },
];

export default function TrialExpired() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-red-500/5 rounded-full blur-[120px]" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-amber-500/5 rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen p-6">
        <div className="w-full max-w-lg text-center space-y-8">
          {/* Icon */}
          <div className="relative inline-block">
            <div className="h-24 w-24 rounded-2xl bg-gradient-to-br from-amber-500/20 to-red-500/20 flex items-center justify-center mx-auto border border-amber-500/20">
              <Clock className="h-12 w-12 text-amber-400" />
            </div>
          </div>

          {/* Title */}
          <div className="space-y-3">
            <h1 className="text-3xl font-bold tracking-tight">
              Seu período de teste acabou
            </h1>
            <p className="text-muted-foreground text-lg max-w-md mx-auto">
              {user?.name ? `${user.name}, seus` : "Seus"} 14 dias de teste gratuito do Manyflows ADS AI expiraram.
              Assine para continuar usando todas as funcionalidades.
            </p>
          </div>

          {/* Features reminder */}
          <div className="grid grid-cols-2 gap-3 max-w-md mx-auto">
            {FEATURES.map((f) => (
              <div
                key={f.label}
                className="flex items-start gap-3 p-3 rounded-xl bg-card/50 border border-border/30 text-left"
              >
                <f.icon className="h-5 w-5 text-muted-foreground shrink-0 mt-0.5" />
                <div>
                  <p className="text-xs font-medium">{f.label}</p>
                  <p className="text-[10px] text-muted-foreground">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="space-y-4">
            <div className="rounded-xl bg-gradient-to-r from-emerald-500/10 to-cyan-500/10 border border-emerald-500/20 p-6 max-w-sm mx-auto space-y-3">
              <div className="flex items-center justify-center gap-2">
                <img src="/assets/logo-manyflows.png" alt="Manyflows" className="h-6" />
                <span className="font-bold text-lg">Manyflows Pro</span>
              </div>
              <p className="text-2xl font-bold text-emerald-400">Em breve</p>
              <p className="text-xs text-muted-foreground">
                Estamos preparando os planos de assinatura. Fique ligado!
              </p>
            </div>

            <Button
              size="lg"
              disabled
              className="gap-2 w-full max-w-sm opacity-50"
            >
              <Rocket className="h-4 w-4" />
              Assinar (em breve)
            </Button>

            <p className="text-xs text-muted-foreground">
              Dúvidas? Entre em contato pelo email{" "}
              <a href="mailto:suporte@iairon.com.br" className="text-primary hover:underline">
                suporte@iairon.com.br
              </a>
            </p>

            <Button
              variant="ghost"
              size="sm"
              onClick={() => logout()}
              className="text-muted-foreground hover:text-foreground"
            >
              Sair da conta
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
